module.exports = __webpack_public_path__ + "img/edit.15b78fb7.svg";